import React, { PropTypes, Component } from 'react'
import styles from './styles'
import Button from 'react-toolbox/lib/button'
import ContentSelect from 'components/contentSelect'
import WeekControl from 'components/weekControl'
import Hint from 'components/hint'

const propTypes = {
  projects: PropTypes.array,
  tasks: PropTypes.array,
  weekReport: PropTypes.object,
  projectShow: PropTypes.array.isRequired,
  taskShow: PropTypes.object,
  thisMonday: PropTypes.object,
  onShowChange: PropTypes.func,
  onWeekChange: PropTypes.func,
  onImportLastWeek: PropTypes.func,
  onWeekReportChange: PropTypes.func,
  showReportButton: PropTypes.bool,
  reviewMode: PropTypes.bool,
}

class TimeSheetControl extends Component {

  constructor (props, context) {
    super(props, context)
    this.onShowClick = () => this.setState({ isShowEditing: !this.state.isShowEditing })
    this.onShowChangeDone = () => this.setState({ isShowEditing: false })

    this.onWeekReportSubmit = () => this.props.onWeekReportChange('submit')
    this.onWeekReportWithdraw = () => this.props.onWeekReportChange('withdraw')
  }

  state = {
    isShowEditing: false,
  };

  render () {
    const {
      projects,
      tasks,
      weekReport,
      projectShow,
      taskShow,
      thisMonday,
      onShowChange,
      onWeekChange,
      onImportLastWeek,
      showReportButton,
      reviewMode,
    } = this.props

    const isShowEditing = this.state.isShowEditing

    const projectEmptyMode = projectShow.length === 0 ? styles.projectEmptyMode : ''
    const cName = `${styles.timesheetControl} ${projectEmptyMode}`

    let reportButton = null

    if (showReportButton) {
      if (reviewMode) {
        if ((weekReport && !weekReport.isDone)) {
          reportButton = (
            <Button
              className={`${styles.timesheetButton} ${styles.overtimePreviewButton}`}
              icon="edit"
              label="收回修改"
              onClick={this.onWeekReportWithdraw}
              flat
            />
          )
        }
      } else {
        reportButton = (
          <Button
            className={`${styles.timesheetButton} ${styles.overtimePreviewButton}`}
            icon="send"
            label="送出審查"
            onClick={this.onWeekReportSubmit}
            flat
          />
        )
      }
    }

    if (reviewMode) {
      return (
        <div className={cName}>
          <WeekControl {...{ onWeekChange, thisMonday }} />
          {reportButton}
        </div>
      )
    }

    return (
      <div className={cName}>
        <WeekControl {...{ onWeekChange, thisMonday }} />
        <div style={{ display: 'inline-block' }}>
          <Button
            className={`${styles.timesheetButton} ${styles.selectProjectButton}`}
            icon={isShowEditing ? 'done' : 'more-vert'}
            label={isShowEditing ? '編輯完成 ' : '選擇專案 '}
            flat
            onClick={this.onShowClick}
          />
          <Hint className={styles.promptProjectText}>這週的專案有什麼？</Hint>
          {isShowEditing ? <ContentSelect
            {...{
              onShowChange,
              projectShow,
              taskShow,
              projects,
              tasks,
              onImportLastWeek,
            }}
            onDone={this.onShowChangeDone}
          /> : null}
        </div>
        {reportButton}
      </div>
    )
  }
}

TimeSheetControl.propTypes = propTypes
export default TimeSheetControl



// WEBPACK FOOTER //
// ./src/app/components/timesheet/control/index.jsx